"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteLabelPublicProvider = void 0;
var react_1 = __importDefault(require("react"));
var useQuoteLabel_1 = require("@CommonFrontend/Quote/useQuoteLabel");
var DefaultLabelFields_1 = __importDefault(require("@CommonFrontend/QuoteV2/Labels/DefaultLabelFields"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var QuoteLabelPublicProvider = function (_a) {
    var accountQuoteSettings = _a.accountQuoteSettings, quoteLabelSetId = _a.quoteLabelSetId, di = _a.di, children = _a.children;
    var getLabel = function (label) {
        var _a, _b, _c;
        var labels = (_a = accountQuoteSettings === null || accountQuoteSettings === void 0 ? void 0 : accountQuoteSettings.labels) !== null && _a !== void 0 ? _a : (_b = di === null || di === void 0 ? void 0 : di.get("accountQuoteSettings")) === null || _b === void 0 ? void 0 : _b.labels;
        (0, tiny_invariant_1.default)(labels);
        return ((_c = labels.find(function (set) { return set.id === quoteLabelSetId; })) === null || _c === void 0 ? void 0 : _c.labels[label]) || DefaultLabelFields_1.default[label];
    };
    return react_1.default.createElement(useQuoteLabel_1.QuoteLabelProvider, { value: getLabel }, children);
};
exports.QuoteLabelPublicProvider = QuoteLabelPublicProvider;
